<template>
	<div>
		<input
			type="number"
			v-model.trim="inputValue"
			:name="name"
			:id="id"
			:autocomplete="autocomplete"
			:placeholder="placeholder"
			:class="inputClassListLive"
			:readonly="readonlyLive"
			:required="requiredLive"
			:disabled="disabledLive"
			:title="inputValue"

			@change="onChangeHandler"
			@input="onInputHandler"
			@focus="onFocusHandler"
			@blur="onBlurHandler"
		>
	</div>
</template>

<script>
	import { baseInput } from './../mixins/index.js';

	export default {
		name: 'NumberInput',

		mixins: [baseInput]
	};
</script>
